import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import {
  FeedKey,
  GroupFragment,
  ProfileSuggestion,
  useFollowMutation,
  UserFeedFollowFragment,
} from 'api';
import { PaddedPaper } from 'components';
import { useNotify } from 'hooks';

import { useFollow } from 'features/groups/updaters';
import SuggestProfile from './SuggestProfile';

interface IProps {
  group: GroupFragment;
  members: UserFeedFollowFragment[];
}

const useStyles = makeStyles({
  root: {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderBottom: 0,
  },
});

const AddMemberInput: FC<IProps> = ({ group, members }) => {
  const classes = useStyles();
  const notify = useNotify();
  const membersById = members.map(member => member.user_id);
  const { t } = useTranslation();

  const mutationOptions = useFollow();
  const { mutateAsync } = useFollowMutation(mutationOptions);

  async function handleAddMember(targetUser: ProfileSuggestion) {
    if (!targetUser) {
      return;
    }

    await mutateAsync({
      id: group.id,
      key: FeedKey.Group,
      target_user_id: targetUser.id,
    });

    const i18nValues = { name: targetUser.title, title: group.title };
    const message = t('groups:addMemberNotify', i18nValues);
    notify.info({ message });
  }

  return (
    <PaddedPaper className={classes.root}>
      <Grid container>
        <Grid item xs={4}>
          <SuggestProfile
            placeholder={t('groups:addToGroup')}
            onChange={handleAddMember}
            excludeIds={membersById}
          />
        </Grid>
      </Grid>
    </PaddedPaper>
  );
};

export default AddMemberInput;
